// Google's popup code flow (Google Identity Services). The browser only ever
// holds a one-time code; the server exchanges it and keeps the grant.
export const GOOGLE_OAUTH_CLIENT_ID = '600002059480-ar848kvmeho14vh0mas69bi36hk39bsg.apps.googleusercontent.com';
export const EVIDENCE_SCOPES = [
  'openid',
  'email',
  'https://www.googleapis.com/auth/calendar.events.readonly',
  'https://www.googleapis.com/auth/contacts.readonly',
];

let gisPromise = null;
function loadGis() {
  if (window.google && window.google.accounts && window.google.accounts.oauth2) return Promise.resolve();
  if (!gisPromise) {
    gisPromise = new Promise((resolve, reject) => {
      const s = document.createElement('script');
      s.src = 'https://accounts.google.com/gsi/client';
      s.async = true;
      s.onload = () => resolve();
      s.onerror = () => { gisPromise = null; reject(new Error('Could not reach Google.')); };
      document.head.appendChild(s);
    });
  }
  return gisPromise;
}

/** Resolves with the code, or null if the member closed the window. */
export async function requestGoogleCode({ loginHint } = {}) {
  await loadGis();
  return new Promise((resolve, reject) => {
    const client = window.google.accounts.oauth2.initCodeClient({
      client_id: GOOGLE_OAUTH_CLIENT_ID,
      scope: EVIDENCE_SCOPES.join(' '),
      ux_mode: 'popup',
      enable_granular_consent: true,
      ...(loginHint ? { login_hint: loginHint } : {}),
      callback: (res) => (res && res.code ? resolve(res.code) : reject(new Error((res && res.error_description) || (res && res.error) || 'Google said no.'))),
      error_callback: (err) => (err && err.type === 'popup_closed' ? resolve(null) : reject(new Error(err && err.type === 'popup_failed_to_open' ? 'Your browser blocked Google’s window. Allow pop-ups for this site and try again.' : 'Google’s window failed.'))),
    });
    client.requestCode();
  });
}
